import _objectWithoutProperties from "/Users/hl/Project/Website/2021/08-\u7DA0\u5CF6\u4EBA\u6B0A\u85DD\u8853\u5B63/website/2021-greenisland/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/hl/Project/Website/2021/08-\u7DA0\u5CF6\u4EBA\u6B0A\u85DD\u8853\u5B63/website/2021-greenisland/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/Users/hl/Project/Website/2021/08-\u7DA0\u5CF6\u4EBA\u6B0A\u85DD\u8853\u5B63/website/2021-greenisland/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import gsap from 'gsap';
var _ = {};
var L = {}; // 지연적으로 동작하는 함수에 네임 스페이스 적용.

_.log = console.log;
/** ============================================================
 * @ 커링
 * 인자가 2개 이상일 경우는 함수에 인자를 전부 넘기면서 실행을 하고
 * 인자가 1개일 경우는 다음에 ...bs를 받는 함수를 리턴하면서
 * 다음번에 실행되도록 한다.
 ============================================================ */

var curry = function curry(f) {
  return function (a) {
    for (var _len = arguments.length, bs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      bs[_key - 1] = arguments[_key];
    }

    return bs.length ? f.apply(void 0, [a].concat(bs)) : function () {
      for (var _len2 = arguments.length, bs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        bs[_key2] = arguments[_key2];
      }

      return f.apply(void 0, [a].concat(bs));
    };
  };
};
/** ============================================================
 * @ 지정된만큼 값을 저장 후 리턴
 ============================================================ */


var take = curry(function (length, iter) {
  var res = [];

  var _iterator = _createForOfIteratorHelper(iter),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var a = _step.value;
      // 순회한 값을 배열에 집어 넣는다.
      res.push(a); // 지정된 length 와 length가 같을 경우에는 저장된 값을 리터

      if (res.length === length) {
        return res;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
});
/** ============================================================
 * @ 전체 평가
============================================================ */

var takeAll = function takeAll(iter) {
  return take(Infinity, iter);
}; // const map = curry((f, iter) => {
//   return takeAll(L.map(f, iter));
// });
// const each = curry((f, iter) => {
//   return map(a => go1(f(a), s => a), iter);
// });

/** ============================================================
 * @ 누적 처리를 함수에게 위임 한다.
 ============================================================ */


var reduce = curry(function (f, acc, iter) {
  // 3번째가 아닌 2번째 파라메터가 이터레이터 일 경우 처리.
  if (arguments.length === 2) {
    iter = acc[Symbol.iterator](); // acc의 iterator을 넘김.

    acc = iter.next().value;
  }

  var _iterator2 = _createForOfIteratorHelper(iter),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var a = _step2.value;
      acc = f(acc, a);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return acc;
});
/** ============================================================
 * @ 리스트가 있다면 함수에 값을 넘겨 주면서 실행 시킨다.
 ============================================================ */

L.map = curry( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(f, iter) {
  var _iterator3, _step3, a;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iterator3 = _createForOfIteratorHelper(iter);
          _context.prev = 1;

          _iterator3.s();

        case 3:
          if ((_step3 = _iterator3.n()).done) {
            _context.next = 9;
            break;
          }

          a = _step3.value;
          _context.next = 7;
          return f(a);

        case 7:
          _context.next = 3;
          break;

        case 9:
          _context.next = 14;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);

          _iterator3.e(_context.t0);

        case 14:
          _context.prev = 14;

          _iterator3.f();

          return _context.finish(14);

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[1, 11, 14, 17]]);
}));
/** ============================================================
 * @ 함수 자체를 축약.
 * a로 시작해서 함수가 들어올 함수로 누적해 나간다.
 * 실행되면 다음과 같은형태로 동작한다. eg) add(add(1, 2), 3)
 ============================================================ */

var go1 = function go1(a, f) {
  return a instanceof Promise ? a.then(f) : f(a);
};

var go = function go() {
  for (var _len3 = arguments.length, as = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    as[_key3] = arguments[_key3];
  }

  return reduce(go1, as);
};
/** ============================================================
* @ 현재 애니메이션의 시간동안 움직일 시간 비율을 구한다.
============================================================ */


var getProgress = function getProgress(_ref) {
  var startY = _ref.startY,
      duration = _ref.duration,
      triggerYPercent = _ref.triggerYPercent;
  var scrollY = window.scrollY;
  var winHeight = window.innerHeight; // _.log('> getProgress : ', startY, duration, triggerYPercent, scrollY, winHeight );

  return Math.max((scrollY - startY + winHeight * triggerYPercent / 100) / duration, 0);
};
/** ============================================================
* @ 현재 프로그래스 셋팅
============================================================ */


var setCurProgress = curry(function (f, data) {
  data.curProgress = getProgress(data);

  if (f) {
    f(data);
  }
});
/** ============================================================
* @ 스무스 애니메이션
============================================================ */

var smoothProgress = function smoothProgress(data) {
  data.ticker = function () {
    var curProgress = data.curProgress,
        tl = data.tl,
        smooth = data.smooth;

    if (curProgress !== undefined) {
      var progress = tl.progress();
      progress += (curProgress - progress) * smooth;
      tl.progress(progress);
    }
  };

  gsap.ticker.add(data.ticker);
};
/** ============================================================
* @ fixed 상태별 처리
============================================================ */


var fixedState = {}; // # 애니메이션 시작 전

fixedState.before = function (data) {
  var els = data.els;
  data.onFixed.status = 'before';
  els.fixedWrapper.style.position = 'static';
  els.fixedWrapper.style.width = "auto";
  els.fixedWrapper.style.height = "0px";
  els.fixedEl.style.position = 'relative';
  els.fixedEl.style.top = "auto";
  els.fixedEl.style.width = "".concat(data.onFixed.width, "px");
  els.fixedEl.style.height = "".concat(data.onFixed.height, "px");
}; // # 애니메이션 중


fixedState.ing = function (data) {
  var els = data.els,
      triggerYPercent = data.triggerYPercent;
  data.onFixed = {
    status: 'ing',
    width: els.fixedEl.offsetWidth,
    height: els.fixedEl.offsetHeight
  };
  els.fixedWrapper.style.position = 'relative';
  els.fixedWrapper.style.width = "".concat(data.onFixed.width, "px");
  els.fixedWrapper.style.height = "".concat(data.onFixed.height, "px");
  els.fixedEl.style.position = "fixed";
  els.fixedEl.style.top = "".concat(triggerYPercent, "%");
  els.fixedEl.style.width = "".concat(data.onFixed.width, "px");
  els.fixedEl.style.height = "".concat(data.onFixed.height, "px");
}; // # 애니메이션 완료


fixedState.completed = function (data) {
  var els = data.els,
      duration = data.duration; // _.log('> log : ', data.onFixed, els.fixedEl.offsetWidth);

  data.onFixed = {
    status: 'completed',
    width: els.fixedEl.offsetWidth,
    height: els.fixedEl.offsetHeight
  };
  els.fixedWrapper.style.position = 'relative';
  els.fixedWrapper.style.width = "".concat(data.onFixed.width, "px");
  els.fixedWrapper.style.height = "".concat(data.onFixed.height, "px");
  els.fixedEl.style.position = "absolute";
  els.fixedEl.style.top = "".concat(duration, "px");
  els.fixedEl.style.width = "".concat(data.onFixed.width, "px");
  els.fixedEl.style.height = "".concat(data.onFixed.height, "px");
};
/** ============================================================
* @ 스크롤 이벤트 콜백
* . removeEvenetListener을 하기 위함.
============================================================ */


var scrollEvtCallback = function scrollEvtCallback(f, data) {
  return function (evt) {
    if (f) {
      f(data);
    } // _.log('> ', data.curProgress)


    if (data.fixedEl) {
      // # 시작전
      if (data.curProgress <= 0 && data.onFixed.status !== 'before') {
        fixedState.before(data);
      } // # 애니메이션 중
      else if (data.curProgress > 0 && data.curProgress <= 1 && data.onFixed.status !== 'ing') {
          fixedState.ing(data);
        } // # 완료
        else if (data.curProgress > 1 && data.onFixed.status !== 'completed') {
            fixedState.completed(data);
          }
    }
  };
};
/** ============================================================
* @ 스크롤 이벤트 바인딩
============================================================ */


var bindScEvt = curry(function (f, data) {
  data.scrollEventFunc = scrollEvtCallback(f, data);
  window.addEventListener('scroll', data.scrollEventFunc, false);
});
/** ============================================================
* @ 이벤트 콜백 연결
============================================================ */

var bindEventCallback = function bindEventCallback(data) {
  var tl = data.tl,
      onStart = data.onStart,
      onUpdate = data.onUpdate; // # 시작 이벤트

  tl.eventCallback('onStart', function () {
    if (onStart) {
      onStart(data);
    }
  }); // # 업데이트

  if (onUpdate) {
    tl.eventCallback('onUpdate', function () {
      return onUpdate(data);
    });
  } // # 완료 이벤트


  tl.eventCallback('onComplete', function () {
    // # fixedEl을 지정했을 경우
    if (data.fixedEl) {
      fixedState.completed(data);
    } // # 콜백 있을 경우 실행


    if (data.onComplete) {
      data.onComplete(data);
    } // # 애니메이션을 한번만 할 경우


    if (data.once === true) {
      kill(data);
    }
  });
};
/** ============================================================
 * @ 스크롤 이벤트
============================================================ */


var evt = {}; // ===== progress

evt.progress = function (data) {
  bindScEvt(setCurProgress(function (_ref2) {
    var tl = _ref2.tl,
        curProgress = _ref2.curProgress,
        smooth = _ref2.smooth;

    if (smooth === 1) {
      tl.progress(curProgress);
    }
  }), data); // # smooth 적용

  if (data.smooth !== 1) {
    smoothProgress(data);
  }

  return data;
}; // ===== trigger


evt.trigger = function (data) {
  bindScEvt(setCurProgress(function (_ref3) {
    var tl = _ref3.tl,
        curProgress = _ref3.curProgress;
    return curProgress > 0 ? tl.play() : tl.reverse();
  }), data);
  return data;
};
/** ============================================================
  * @ indicator 엘리먼트 생성
============================================================ */


var fixedElWrapperTemplate = function fixedElWrapperTemplate() {
  return "<div style=\"top:auto;bottom:auto;left:auto;right:auto;margin:auto;display:block;width:auto;min-width:1px;line-height:0;height:0;\"></div>";
};

var indicatorTemplate = function indicatorTemplate(_ref4) {
  var startY = _ref4.startY,
      endY = _ref4.endY,
      type = _ref4.type,
      startIndicatorName = _ref4.startIndicatorName,
      endIndicatorName = _ref4.endIndicatorName;
  return "<div style=\"position:absolute;right:20px;top:".concat(startY, "px;overflow:visible;white-space:nowrap;font-size:0.8rem;z-index:10000;text-align:right;\">\n    <div style=\"padding:0 5px;border-bottom:1px solid;line-height:0.9rem;color:blue;min-width:20px;margin-top:-0.9rem\">").concat(startIndicatorName, "</div>\n    ").concat(type === 'progress' ? "<div style=\"position:absolute;top:".concat(endY, "px;padding:0 5px;border-top:1px solid;line-height:0.9rem;color:red;min-width:20px;\">").concat(endIndicatorName, "</div>") : '', "\n  </div>");
};

var triggerTemplate = function triggerTemplate(_ref5) {
  var triggerYPercent = _ref5.triggerYPercent,
      triggerIndicatorName = _ref5.triggerIndicatorName;
  return "<div style=\"position:fixed;right:20px;top:".concat(triggerYPercent, "%;overflow:visible;white-space:nowrap;font-size:0.8rem;line-height:0.9rem;z-index:10001;\">\n    <div style=\"color:green;line-height:0.95rem;border-bottom:1px solid;min-width:50px;\">\n      <div style=\"position:absolute;top:-0.9rem;\">").concat(triggerIndicatorName, "</div>\n    </div>\n  </div>");
};
/** ============================================================
  * @ 텍스트를 엘리먼트로 변경.
============================================================ */


var el = function el(html) {
  var wrap = document.createElement("div");
  wrap.innerHTML = html;
  return wrap.children[0];
};
/** ============================================================
  * @ 다른 엘리먼트로 덮어 싸기
============================================================ */


var wrapEl = function wrapEl(_el, _wrapper) {
  _el.parentNode.insertBefore(_wrapper, _el);

  _wrapper.appendChild(_el);
};
/** ============================================================
 * @ 엘리먼트내에 다른 엘리먼트 덧붙임.
============================================================ */


var append = function append(parent, child) {
  return parent.appendChild(child);
};
/** ============================================================
 * @ 시작
============================================================ */


var play = function play(type) {
  return function (tls, options) {
    var els = setElement(options); // 엘리먼트 셋팅

    return go(tls, L.map(setOptions(_objectSpread(_objectSpread({}, options), {}, {
      els: els,
      type: type
    }))), // 옵션 셋팅
    L.map(function (a) {
      return evt[type](a), a;
    }), // 스크롤 이벤트 바인딩
    L.map(function (a) {
      return bindEventCallback(a), a;
    }), // 이벤트 콜백 바인딩
    takeAll, // 전체 평가
    function (tls) {
      return tls[0].showIndicator && indicator(tls[0]), tls;
    }, // indicator 생성
    function (a) {
      return window.scrollBy(window.scrollX, 1), a;
    }, // 스크롤 이벤트
    function (a) {
      return {
        tls: a,
        killAll: function killAll() {
          return _killAll(a);
        },
        els: els
      };
    } // 리턴 데이터 추가
    );
  };
};
/** ============================================================
 * @ 옵션셋팅
============================================================ */


var setOptions = curry(function (_ref6, tl) {
  var els = _ref6.els,
      _options = _objectWithoutProperties(_ref6, ["els"]);

  var options = _objectSpread({
    type: 'progress',
    // 애니메이션 방식("trigger"[트리거로 한번만 실행], "progress"[duration동안 실행])
    triggerEl: undefined,
    // 트리거의 기준이 되는 엘리먼트.
    fixedEl: undefined,
    // onComplete 발생시까지 고정된다.
    startY: els.triggerEl.offsetTop,
    // 애니메이션 시작 좌표(px)
    triggerYPercent: 50,
    // 트리거 y 축 좌표(%)
    showIndicator: false,
    // indicator 표시 유무
    duration: 100,
    // 애니메이션 스크롤 기간(px, progress only)
    smooth: 1,
    // 부드럽게 움직임 옵션 추가.(progress only: 0.01 ~ 1)
    once: false,
    // 한번만 애니메이션 함.(onComplete 이후 kill)
    onStart: undefined,
    // 애니메이션 start 시 이벤트
    onUpdate: undefined,
    // update 시 지속 이벤트
    onComplete: undefined,
    // 애니메이션 완료 시 이벤트
    onFixed: {
      status: 'ready'
    },
    // fixedEl 시 상태 저장값. (ready, before, ing, completed)
    startIndicatorName: 'start',
    endIndicatorName: 'end',
    triggerIndicatorName: 'trigger'
  }, _options); // _.log('> ', options.type)


  return _objectSpread({
    tl: tl,
    els: els
  }, options);
});
/** ============================================================
 * @ 엘리먼트 셋팅
============================================================ */

var setElement = function setElement(_ref7) {
  var triggerEl = _ref7.triggerEl,
      fixedEl = _ref7.fixedEl;
  var els = {};
  els.triggerEl = document.querySelector(triggerEl); // # 고정 엘리먼트.

  if (fixedEl) {
    els.fixedEl = document.querySelector(fixedEl); // fixed 엘리먼트 선택

    els.fixedWrapper = el(fixedElWrapperTemplate({
      height: els.fixedEl.offsetHeight
    }));
    wrapEl(els.fixedEl, els.fixedWrapper);
  }

  return els;
};
/** ============================================================
 * @ indicator 생성
============================================================ */


var indicator = function indicator(_ref8) {
  var startY = _ref8.startY,
      duration = _ref8.duration,
      triggerYPercent = _ref8.triggerYPercent,
      type = _ref8.type,
      startIndicatorName = _ref8.startIndicatorName,
      endIndicatorName = _ref8.endIndicatorName,
      triggerIndicatorName = _ref8.triggerIndicatorName;
  // console.log('> indicator : ', endIndicatorName);
  // # 인디케이터 생성
  append(document.body, el(indicatorTemplate({
    startY: startY,
    endY: duration,
    type: type,
    startIndicatorName: startIndicatorName,
    endIndicatorName: endIndicatorName
  }))); // # 트리거 생성.

  append(document.body, el(triggerTemplate({
    triggerYPercent: triggerYPercent,
    triggerIndicatorName: triggerIndicatorName
  })));
};
/** ============================================================
 * @ 모든 이벤트를 언바인딩 시키고 작동을 멈춘다.
============================================================ */


var _killAll = function _killAll(data) {
  var _iterator4 = _createForOfIteratorHelper(data),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var a = _step4.value;
      kill(a);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
};

var kill = function kill(_ref9) {
  var tl = _ref9.tl,
      scrollEventFunc = _ref9.scrollEventFunc;
  window.removeEventListener('scroll', scrollEventFunc);
  tl.clear();
  tl.kill();
};
/** ============================================================
* @ 외부 노출 객체
* gsap scroll 애니메이션 객체
============================================================ */


var gsapc = {}; // ===== 타입별 메소드`

gsapc.progress = play('progress');
gsapc.trigger = play('trigger');
export default gsapc;